import React, { useMemo } from "react";
import { usePlanningStore, getCategories } from "@store/planningStore";
import { useDataStore } from "@store/user_org";

export function CategoryFilters() {
  const activeCategories = usePlanningStore((s) => s.activeCategories);
  const toggleCategory = usePlanningStore((s) => s.toggleCategory);
  const orgData = useDataStore((s) => s.orgData);
  const categories = useMemo(() => getCategories(orgData), [orgData]);

  return (
    <div className="flex flex-row flex-wrap">
      {categories.map((cat, index) => {
        const active = activeCategories.includes(cat.id);
        const isFirst = index === 0;
        const isLast = index === categories.length - 1;
        return (
          <button
            key={cat.id}
            onClick={() => toggleCategory(cat.id)}
            className={`py-2 px-4 text-sm font-medium whitespace-nowrap transition-colors duration-200 border
              ${isFirst ? "rounded-l-lg" : ""}
              ${isLast ? "rounded-r-lg" : ""}
              ${active ? "shadow-md" : "shadow-inner border-transparent"}`}
            style={{
              background: active ? cat.bgColor : undefined,
              color: active ? cat.color : "#A1A1A1",
              borderColor: active ? cat.borderColor : "transparent",
            }}
          >
            {cat.label}
          </button>
        );
      })}
    </div>
  );
}
